import http from './ApiConfig';
import { Service } from './Service';
import { FeriadoApiResponseOutputType } from '@/types/feriados/FeriadoApiResponseOutputType';
import { FeriadoSincronizacaoOutputType } from '@/types/feriados/FeriadoSincronizacaoOutputType';

export class FeriadoAgendaService extends Service {
  constructor() {
    super('feriado');
  }

  public ObterTodosOsFeriados() {
    return http.get(`${this._nomeControle}`, this.GetHeader());
  }

  public ObterFeriadosNacionais(ano: number): Promise<FeriadoApiResponseOutputType> {
    return http.get(`${this._nomeControle}/nacionais?ano=${ano}`, this.GetHeader());
  }

  public ObterFeriadosEstaduais(uf: string, ano: number): Promise<FeriadoApiResponseOutputType> {
    return http.get(`${this._nomeControle}/estaduais?uf=${uf}&ano=${ano}`, this.GetHeader());
  }

  public ObterFeriadosMunicipais(uf: string, ano: number, municipio: string): Promise<FeriadoApiResponseOutputType> {
    return http.get(`${this._nomeControle}/municipais?uf=${uf}&ano=${ano}&municipio=${municipio}`, this.GetHeader());
  }

  public SincronizarFeriadosNaAgendaDoUsuario(usuarioId: string): Promise<FeriadoSincronizacaoOutputType> {
    return http.get(`${this._nomeControle}/sincronizar?usuarioId=${usuarioId}`, this.GetHeader());
  }
}
